import { render } from "./ComplexHeaderDatatable.vue?vue&type=template&id=5cf27e4e"
import script from "./ComplexHeaderDatatable.vue?vue&type=script&lang=js"
export * from "./ComplexHeaderDatatable.vue?vue&type=script&lang=js"

import "./ComplexHeaderDatatable.vue?vue&type=style&index=0&id=5cf27e4e&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__